import { createFileRoute, Link } from "@tanstack/react-router";
import {
  BrandFooter,
  BrandHeader,
  Wordmark,
} from "@/components/runboom/marks";
import { WallEvent } from "@/components/runboom/wall-event";
import { wall } from "@/lib/mock";

export const Route = createFileRoute("/wall")({
  component: WallPage,
});

function WallPage() {
  return (
    <main className="mx-auto max-w-[920px] px-5 py-6 sm:px-8 sm:py-10">
      <BrandHeader rightTab="The Wall" rightTabTone="lime" />

      <div className="mt-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <Wordmark size="sm" />
        </Link>
        <nav className="flex items-center gap-3 font-mono text-[12px] uppercase tracking-[0.1em] text-fg-muted sm:gap-5">
          <Link to="/oracle" className="hidden hover:text-fg sm:inline">Oracle</Link>
          <Link to="/races" className="hidden hover:text-fg sm:inline">Races</Link>
          <Link
            to="/leaderboards"
            search={{ distance: "10K", city: "Cape Town" }}
            className="hidden hover:text-fg sm:inline"
          >
            Leaderboards
          </Link>
          <Link
            to="/me"
            className="rounded-full px-3 py-1.5 text-night transition-transform hover:scale-[1.02]"
            style={{ backgroundColor: "var(--color-acid-lime)" }}
          >
            Connect Strava
          </Link>
        </nav>
      </div>

      <header className="mt-8">
        <div className="font-mono text-[11px] uppercase tracking-[0.12em]" style={{ color: "var(--color-blood-orange)" }}>
          Live · your crew + your city
        </div>
        <h1 className="mt-3 font-display-italic font-display text-[56px] leading-[48px] tracking-[-0.015em] text-fg sm:text-[88px] sm:leading-[76px] lg:text-[120px] lg:leading-[100px]">
          THE WALL.
        </h1>
        <p className="mt-6 max-w-[60ch] font-mono text-[12px] uppercase tracking-[0.12em] text-fg-muted">
          Every PB, every line, every rivalry from the people you race against.
          <span className="ml-1" style={{ color: "var(--color-blood-orange)" }}>BOOMs first.</span>
        </p>
      </header>

      <section className="mt-8 flex flex-col gap-3 sm:mt-10">
        {wall.map((event) => (
          <WallEvent key={event.id} event={event} />
        ))}
      </section>

      <BrandFooter />
    </main>
  );
}
